import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { TranslateModule } from '@ngx-translate/core'

export type ModifySessionSectionId = 'balances' | 'charges' | 'insurances' | 'benefits' | 'charity-care'

@Component({
  selector: 'mmx-modify-session-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, TranslateModule],
  templateUrl: './modify-session-section.component.html',
  styleUrls: ['./modify-session-section.component.scss'],
})
export class ModifySessionSectionComponent {
  @Input({ required: true }) section!: ModifySessionSectionId
  @Input() expanded = false

  get translationKey(): string {
    return `balance.modify-session.section.${this.section}`
  }
}
